<template>
<div id="mptemsg">
  <b-field position="is-centered" class="box">
    <h1>发送模版消息给玩家，目前仅支持 QQ 小游戏 和 微信小游戏</h1>
    <a class="button is-text" href="https://q.qq.com/wiki/develop/miniprogram/server/open_port/port_module.html#sendtemplatemessage" target="_blank">QQ小游戏通知模板消息文档</a>
    <a class="button is-text" href="https://developers.weixin.qq.com/minigame/dev/api-backend/open-api/subscribe-message/subscribeMessage.send.html#method-http" target="_blank">微信小游戏通知模板消息文档</a>
  </b-field>
  <hr />
  <b-field horizontal label="MP配置名称">
    <b-input v-model="msgConfigName" placeholder="输入MP配置中的名称，不含 r_ 前缀"/>
  </b-field>
  <b-field horizontal label="openid">
    <textarea v-model="msgOpenid" class="textarea" placeholder="输入玩家的 openid，每行一个。若MP配置中指定发送给所有人，则留空" />
  </b-field>
  <b-field horizontal label="data">
    <textarea v-model="msgData" class="textarea" placeholder="输入模版消息的值，每行一个" />
  </b-field>
  <b-field horizontal label="page">
    <b-input v-model="msgPage" placeholder="点击模板卡片后的跳转页面，仅限本小程序内的页面。支持带参数,（示例index?foo=bar）。该字段不填则模板无跳转。"/>
  </b-field>
  <b-field horizontal label="emphasis_keyword">
    <b-input v-model="msgEmphasisKeyword" placeholder="模板需要放大的关键词，不填则默认无放大"/>
  </b-field>
  <b-field horizontal label="消息发到哪去">
      <b-radio v-model="platform"
                native-value="qq">
                QQ
      </b-radio>
      <b-radio v-model="platform"
          native-value="wx">
          微信
      </b-radio>
  </b-field>
  <b-field>
    <button class="button is-danger" :disabled="!canSend" @click="onSendMessage">发送消息</button>
  </b-field>
  <b-table :data="histories"
        paginated backend-pagination
        :total="total"
        :per-page="perPage"
        :current-page="currentPage"
        detailed detail-key="hid"
        @page-change="onPageChange">
    <template slot-scope="props">
      <b-table-column field="hid" label="hid" width="100">
        {{ props.row.hid }}
      </b-table-column>
      <b-table-column field="adminuid" label="adminuid" width="100">
        {{ props.row.adminuid }}
      </b-table-column>
      <b-table-column field="nickname" label="管理员昵称" width="180">
        {{ props.row.nickname }}
      </b-table-column>
      <b-table-column field="status" label="status" width="100">
        {{ props.row.status }}
      </b-table-column>
      <b-table-column field="r" label="regional" width="100">
        {{ props.row.r }}
      </b-table-column>
      <b-table-column field="typeid" label="typeid" width="80">
        {{ props.row.typeid }}
      </b-table-column>
      <b-table-column field="note" label="说明">
        {{ props.row.note }}
      </b-table-column>
      <b-table-column field="createtime" label="操作时间" width="200">
        {{ formatDateTime(props.row.createtime) }}
      </b-table-column>
    </template>
    <template slot="bottom-left">
      <b>总计：</b>{{ total }}
    </template>
    <template slot="detail" slot-scope="{row}">
      <p v-for="(v, k) in row" :key="k">{{k}}: {{v}}</p>
    </template>
  </b-table>
</div>
</template>

<script>
/**
 * 发送模版消息给玩家
 */
import config from '@/core/config'

export default {
  name: 'mptemsg',
  mounted () {
    this.getRecords()
  },
  computed: {
    canSend () {
      return this.msgConfigName && this.msgDataParsed
    },
    msgDataParsed () {
      return this.parseMsgData()
    },
    msgOpenidParsed () {
      return this.parseMsgOpenid()
    }
  },
  data () {
    return {
      msgConfigName: null,
      msgOpenid: null,
      msgPage: null,
      msgEmphasisKeyword: null,
      msgData: null,
      perPage: config.PER_PAGE,
      platform: 'qq',
      currentPage: 1,
      histories: [],
      total: 0
    }
  },
  methods: {
    async getRecords (page) {
      page = page || this.currentPage || 1
      try {
        const filterobj = { page, per_page: this.perPage, alladmin: 1, typeid: 1001 }
        const rdata = await this.mjp.get2({
          url: '/admin/history/get/more/',
          query: filterobj,
          msgType: 'admin'
        })
        this.histories = rdata.histories
        this.total = rdata.total
        this.perPage = rdata.per_page
        this.page = rdata.page
      } catch (error) {
        console.error(error)
      }
    },
    onPageChange (page) {
      this.currentPage = page
      this.getRecords(page)
    },
    parseMsgData () {
      if (this.msgData) {
        const data = this.msgData.trim().split('\n')
        if (data.length > 0) {
          const dataObj = {}
          let i = 0
          while (data.length > 0) {
            const valueStr = data.shift().trim()
            if (valueStr) {
              dataObj['keyword' + (i + 1)] = { value: valueStr }
              i++
            }
          }
          return dataObj
        }
      }
      return null
    },
    parseMsgOpenid () {
      if (this.msgOpenid) {
        const data = this.msgOpenid.trim().split('\n')
        if (data.length > 0) {
          // windows 下面换行符可能是 \r\n
          return data.map(x => x.trim())
        }
      }
      return null
    },
    async onSendMessage () {
      const msgInfo = {
        page: this.msgPage,
        touser: this.parseMsgOpenid(),
        data: this.parseMsgData(),
        emphasis_keyword: this.msgEmphasisKeyword,
        platform: this.platform
      }
      // 根据平台进行判断
      let apiUrl = ''
      if (msgInfo.platform === 'qq') {
        apiUrl = '/qq2mini/sendtemsg/'
      } else if (msgInfo.platform === 'wx') {
        apiUrl = '/wxmini/sendtemsg/'
      } else {
        return
      }
      try {
        await this.mjp.post2({
          url: apiUrl,
          data: {
            name: this.msgConfigName,
            info: msgInfo
          },
          mjpType: 'mp'
        })
        this.getRecords()
      } catch (e) {
        console.error(e)
      }
    }
  }
}

</script>

<style>
#mptemsg {
  padding: 12px;
}
</style>
